import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Alert, notification, Switch, Table, Space, Card, Checkbox, Modal, Descriptions } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { inject, observer } from 'mobx-react'

import "./style.scss";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;

const AddMockVoting = ({ mockElectionStore, voterStore }) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [selectedVoter, setSelectedVoter] = useState()
    const [searchName, setSearchName] = useState();
    const [selectedSenator, setSelectedSenator] = useState([]);
    const [selectedCongressmans, setSelectedCongressmans] = useState([]);
    const [selectedGovernors, setSelectedGovernors] = useState([]);
    const [selectedViceGovernors, setSelectedViceGovernors] = useState([]);
    const [selectedSangguniangPanlalawigan, setSelectedSangguniangPanlalawigan] = useState([]);
    const [selectedMayors, setSelectedMayors] = useState([]);
    const [selectedViceMayors, setSelectedViceMayors] = useState([]);
    const [selectedSangguniangBayan, setSelectedSangguniangBayan] = useState([]);
    const [isOpenReviewModal, setIsOpenReviewModal] = useState(false)
    const [toReviewData, setToReviewData] = useState()
    const [toSubmitData, setToSubmitData] = useState()
    
    useEffect(() => {
        if(selectedVoter) {
            form.setFieldsValue(selectedVoter)
        }
    }, [selectedVoter])

    useEffect(() => {
        mockElectionStore.isAlreadyVoted = false
        voterStore.page = 1;
        voterStore.hasMore = false;
        voterStore.perPage = 5;
        voterStore.fetchVoters();
        mockElectionStore.fetchCandidates();
    }, [])

    const handlePrevPage = () => {
        voterStore.page = voterStore.page - 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
        
    };

    const handleNextPage = () => {
        voterStore.page = voterStore.page + 1;
        if(searchName){
            voterStore.searchVoters(searchName);
        }else{
            voterStore.fetchVoters();
        }
    };

    const handleChangeSenator = (checkedValues) => {
        if (checkedValues.length <= 12) {
            setSelectedSenator(checkedValues);
        }
    };

    const handleChangeCongressmans = (checkedValues) => {
        if (checkedValues.length <= 1) {
            setSelectedCongressmans(checkedValues);
        }
    };

    const handleChangeGovernors = (checkedValues) => {
        if (checkedValues.length <= 1) {
            setSelectedGovernors(checkedValues);
        }
    };

    const handleChangeViceGovernors = (checkedValues) => {
        if (checkedValues.length <= 1) {
            setSelectedViceGovernors(checkedValues);
        }
    };

    const handleChangeSangguniangPanlalawigan = (checkedValues) => {
        if (checkedValues.length <= 2) {
            setSelectedSangguniangPanlalawigan(checkedValues);
        }
    };

    const handleChangeMayors = (checkedValues) => {
        if (checkedValues.length <= 1) {
            setSelectedMayors(checkedValues);
        }
    };

    const handleChangeViceMayors = (checkedValues) => {
        if (checkedValues.length <= 1) {
            setSelectedViceMayors(checkedValues);
        }
    };

    const handleChangeSangguniangBayan = (checkedValues) => {
        if (checkedValues.length <= 8) {
            setSelectedSangguniangBayan(checkedValues);
        }
    };


    const handleSearchVoter = () => {
        if (!searchName){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else if(searchName == ""){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a Voter Name'
            });
            return;
        } else{
            voterStore.searchVoters(searchName);
        }
    };

    const onProceed = () => {
        const dataToReview = {
            vin: selectedVoter.VIN,
            senators: selectedSenator,
            congressmans: selectedCongressmans,
            governors: selectedGovernors,
            viceGovernors: selectedViceGovernors,
            sangguniangPanlalawigan: selectedSangguniangPanlalawigan,
            mayors: selectedMayors,
            viceMayors: selectedViceMayors,
            sangguniangBayan: selectedSangguniangBayan,
        };

        const data = {
            vin: selectedVoter.VIN,
            senators: selectedSenator.map((candidate) => candidate.BallotID),
            congressmans: selectedCongressmans.map((candidate) => candidate.BallotID),
            governors: selectedGovernors.map((candidate) => candidate.BallotID),
            viceGovernors: selectedViceGovernors.map((candidate) => candidate.BallotID),
            sangguniangPanlalawigan: selectedSangguniangPanlalawigan.map((candidate) => candidate.BallotID),
            mayors: selectedMayors.map((candidate) => candidate.BallotID),
            viceMayors: selectedViceMayors.map((candidate) => candidate.BallotID),
            sangguniangBayan: selectedSangguniangBayan.map((candidate) => candidate.BallotID),
        };

        setIsOpenReviewModal(true)
        setToReviewData(dataToReview)
        setToSubmitData(data)
    }

    const onSubmit = (values) => {
        Swal.fire({
            title: "Save Vote",
            icon: "question",
            text: "Are you sure you want to submit this vote?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: `Cancel`
        }).then((result) => {
            if (result.isConfirmed) {
               mockElectionStore.createVote(values);
            } 
        })
    }

    const columns = [
        {
          title: 'Name',
          key: 'FullName+ID',
          dataIndex: 'FullName',
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
          title: 'Precinct',
          key: 'Precint+ID',
          dataIndex: 'Precint',
          render: (Precint) => (
            <Text default>{Precint}</Text>
          )
        },
        {
          title: 'Street',
          key: 'Street+ID',
          dataIndex: 'Street',
          render: (Street) => (
            <Text default>{Street}</Text>
          )
        },
        {
          title: 'Address',
          key: 'Address+ID',
          dataIndex: 'Address',
          render: (Address) => (
            <Text default>{Address}</Text>
          )
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          fixed: "right",
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => {
                        setSelectedVoter(record)
                        mockElectionStore.validateIfAlreadyVoted({
                            vin: record.VIN
                        })
                    }}
                >Select</Button>
            </Space>
          )
        },
    ];

    return (
        <div className="team-leader-mock-election">
            {mockElectionStore.isAlreadyVoted === false ? (
                <Content>
                    <div className="team-leader-mock-election-content">
                        <Title level={5}><SearchOutlined /> Search Voter</Title>
                        <Row gutter={10}>
                            <Col>
                                <Input
                                    placeholder="Enter name"
                                    allowClear
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <Button type="primary" icon={<SearchOutlined />} onClick={handleSearchVoter}>Search User</Button>
                            </Col>
                        </Row>
                        <Divider/>
                        <Table pagination={false} columns={columns} dataSource={voterStore.voters} scroll={{ x: "max-content" }} bordered/>
                        <ul className="pagination">
                            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                            <li className="pagination-item"><a>{voterStore.page}</a></li>
                            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                        </ul>
                    </div>
                </Content>
                
            ): (
                <Content>
                    {/* <Form 
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={form}
                    > */}
                        <div className="team-leader-mock-election-content">
                            <Title level={4}>Mock Election Form</Title>
                            <Divider />
                            <Row justify={'center'} gutter={10}>
                                <div className="form-container">
                                    <Title level={4}>Voter's Information</Title>
                                    <Descriptions column={{xs: 1 , sm: 1, md: 1, lg: 2, xl: 2, xxl: 2}} bordered>
                                        <Descriptions.Item label="VIN">{selectedVoter.VIN}</Descriptions.Item>
                                        <Descriptions.Item label="Name">{selectedVoter.FullName}</Descriptions.Item>
                                        <Descriptions.Item label="Precinct">{selectedVoter.Precint}</Descriptions.Item>
                                        <Descriptions.Item label="Street">{selectedVoter.Street}</Descriptions.Item>
                                        <Descriptions.Item label="Address">{selectedVoter.Address}</Descriptions.Item>
                                    </Descriptions>  
                                    <Divider/>          
                                    <Card className="card-container">
                                        <Title level={3}>SENATOR</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 12 (Bumoto ng hindi higit sa 12)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedSenator} onChange={handleChangeSenator}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.senators?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>MEMBER OF HOUSE OF REPRESENTATIVES</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 1 (Bumoto ng hindi higit sa 1)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedCongressmans} onChange={handleChangeCongressmans}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.congressmans?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>PROVINCIAL GOVERNOR</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 1 (Bumoto ng hindi higit sa 1)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedGovernors} onChange={handleChangeGovernors}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.governors?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>PROVINCIAL VICE-GOVERNOR</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 1 (Bumoto ng hindi higit sa 1)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedViceGovernors} onChange={handleChangeViceGovernors}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.viceGovernors?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>MEMBER, SANGGUNIANG PANLALAWIGAN</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 2 (Bumoto ng hindi higit sa 2)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedSangguniangPanlalawigan} onChange={handleChangeSangguniangPanlalawigan}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.sangguniangPanlalawigan?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>MAYOR</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 1 (Bumoto ng hindi higit sa 1)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedMayors} onChange={handleChangeMayors}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.mayors?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>VICE-MAYOR</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 1 (Bumoto ng hindi higit sa 1)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedViceMayors} onChange={handleChangeViceMayors}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.viceMayors?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>

                                    <Card className="card-container">
                                        <Title level={3}>MEMBER, SANGGUNIANG BAYAN</Title>
                                        <div>
                                            <Title level={5} type="secondary" italic>Vote for 8 (Bumoto ng hindi higit sa 8)</Title>
                                        </div>
                                        <Divider/>
                                        <Checkbox.Group value={selectedSangguniangBayan} onChange={handleChangeSangguniangBayan}>
                                            <Space direction="vertical"> 
                                                {mockElectionStore.sangguniangBayan?.map((option) => (
                                                    <Checkbox value={option}>
                                                        {option.BallotID}. {option.CandidateName}
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Checkbox.Group>
                                    </Card>
                                </div>
                            </Row>
                            <Divider/>
                            <Row justify={'end'} gutter={12}>
                                <Col>
                                    <Button type="primary" icon={<PlusOutlined/>} loading={voterStore.loading} onClick={onProceed}>Proceed</Button>
                                </Col>
                                <Col>
                                    <Button onClick={() => navigate(-1)} loading={voterStore.loading}>Back</Button>
                                </Col>
                            </Row>
                        </div>
                    {/* </Form> */}
                    <Modal 
                        title="Review Vote" 
                        open={isOpenReviewModal} 
                        onCancel={() => setIsOpenReviewModal(false)}
                        footer={[
                            <Button key="cancel" onClick={() => setIsOpenReviewModal(false)}>Cancel</Button>,
                            <Button key="submit" type="primary" onClick={() => onSubmit(toSubmitData)}>Submit Vote</Button>
                        ]}
                    >
                        <Alert
                            description="Please review your vote before proceeding to submit."
                            type="warning"
                            showIcon
                        />
                        <Divider/>
                        <Text>VIN: {toReviewData?.vin}</Text>
                        <Divider/>
                        <Title level={5}>SENATORS ({toReviewData?.senators.length} Selected)</Title>
                        {toReviewData?.senators.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}

                        <Title level={5}>MEMBER OF HOUSE OF REPRESENTATIVES ({toReviewData?.congressmans.length} Selected)</Title>
                        {toReviewData?.congressmans.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}

                        <Title level={5}>PROVINCIAL GOVERNOR ({toReviewData?.governors.length} Selected)</Title>
                        {toReviewData?.governors.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                        
                        <Title level={5}>PROVINCIAL VICE-GOVERNOR ({toReviewData?.viceGovernors.length} Selected)</Title>
                        {toReviewData?.viceGovernors.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                        
                        <Title level={5}>MEMBER, SANGGUNIANG PANLALAWIGAN ({toReviewData?.sangguniangPanlalawigan.length} Selected)</Title>
                        {toReviewData?.sangguniangPanlalawigan.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                        
                        <Title level={5}>MAYOR ({toReviewData?.mayors.length} Selected)</Title>
                        {toReviewData?.mayors.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                        
                        <Title level={5}>VICE-MAYOR ({toReviewData?.viceMayors.length} Selected)</Title>
                        {toReviewData?.viceMayors.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                        
                        <Title level={5}>MEMBER, SANGGUNIANG BAYAN ({toReviewData?.sangguniangBayan.length} Selected)</Title>
                        {toReviewData?.sangguniangBayan.map((candidate) => (
                            <div><Text>{candidate.BallotID}. {candidate.CandidateName}</Text></div>
                        ))}
                    </Modal>
                </Content>
            )}
        </div>
    );
};

export default inject('mockElectionStore', 'voterStore')(observer(AddMockVoting));
